import styled from "styled-components";

export const StyledPlansContainer = styled.div`
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  
  .ant{
    &-radio-group-solid{
      display: flex;
      .ant-radio-button-wrapper{
        height: 64px;
        padding: 20px 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        border-radius: 0;
      }
      
      .ant-radio-button-wrapper-checked{
        border: none;
      }
    }
  }
`

export const StyledRadioSwitchContainer = styled.div`
  background-color: #fff;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  box-shadow: 0px 8px 16px 0px #132D2A14;
  z-index: 5;
  position: relative;
`

export const StyledTabsContainer = styled.div`
  background:#FAFAFA;
  height: 56px;
  
  .ant{
    &-tabs-nav{
      height: 56px;
      &-list{
        margin-left: 24px;
      }
    }
  }
`

export const PlanCard = styled.div`


  &:hover{
    background: var(--c-light-hover);
    border-color: var(--c-dark-press);
  }
  
  
  margin-bottom: 8px !important;
  padding: 12px 16px;
  border-radius: 4px;
  border: 1px solid #E8E8E8; //border-color

  span {
    font-size: 14px;
    line-height: 20px;
    color: #49494D; //странный цвет
  }
`;